import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './add-on-insights.component.scss';
var AddOnInsights = /** @class */ (function (_super) {
    tslib_1.__extends(AddOnInsights, _super);
    function AddOnInsights(element) {
        return _super.call(this, element) || this;
    }
    AddOnInsights.prototype.init = function () {
    };
    AddOnInsights.prototype.bindEvents = function () {
    };
    return AddOnInsights;
}(Base));
export { AddOnInsights };



//////////////////
// WEBPACK FOOTER
// ./components/add-on-insights/add-on-insights.component.ts
// module id = 84
// module chunks = 0